import { NavLink, Outlet } from 'react-router-dom';
import { useQboStatus } from '../api/hooks';
import type { SessionUser } from '../api/types';

export function Layout({ user }: { user: SessionUser }) {
  const qbo = useQboStatus();
  const isApprover = user.role === 'approver';
  const connected = qbo.data?.connected ?? false;

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          Tricord <span>Quotes</span>
        </div>
        <nav>
          <NavLink to="/create">✨ Create</NavLink>
          <NavLink to="/" end>
            Quotes
          </NavLink>
          <NavLink to="/quotes/new">New Quote</NavLink>

          <div className="nav-section">Records</div>
          <NavLink to="/items" end>
            Items
          </NavLink>
          <NavLink to="/customers/new">Add Customer</NavLink>
          <NavLink to="/items/new">Add Item / Service</NavLink>
          <NavLink to="/suppliers/new">Add Supplier</NavLink>

          {isApprover && (
            <>
              <div className="nav-section">Admin</div>
              <NavLink to="/admin/users">Users &amp; Audit</NavLink>
            </>
          )}
        </nav>
      </aside>

      <div className="main">
        <div className="topbar">
          {qbo.data && (
            <span className="muted" style={{ marginRight: 'auto', fontSize: '0.8rem' }}>
              QuickBooks:{' '}
              <strong style={{ color: connected ? 'var(--status-invoiced)' : 'var(--status-rejected)' }}>
                {connected ? `connected (${qbo.data.environment})` : qbo.data.status}
              </strong>
            </span>
          )}
          <div className="who">
            <div>
              {user.displayName} <span className={`badge role-${user.role}`}>{user.role}</span>
            </div>
            <div className="upn">{user.upn}</div>
          </div>
          <a className="btn" href="/auth/logout">
            Sign out
          </a>
        </div>

        <div className="content">
          {!connected && (
            <div className="banner warn">
              <span>
                QuickBooks is not connected{qbo.data?.status === 'reprovision_needed' ? ' (re-authorization required)' : ''}.
                {isApprover ? ' Connect the company to start creating quotes.' : ' Ask an approver to connect QuickBooks.'}
              </span>
              {isApprover && (
                <a className="btn primary" href="/qbo/connect">
                  Connect QuickBooks
                </a>
              )}
            </div>
          )}
          <Outlet />
        </div>
      </div>
    </div>
  );
}
